import React, { memo, useEffect, useState, useCallback, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
// import classNames from 'classnames';
// import { message } from 'antd';
import copy from 'copy-to-clipboard';

import { todayDownloadApp } from '../../constants/storageKeys';
// import Rate from '../../components/Rate/Rate';
import { logging } from '../../actions/log';
// import { getAAppGift, appAGiftReceive } from '../../actions/adetail';
import styles from './SoftDetailGift.module.less';
// import success from '../../static/msg-success.svg';
// import fail from '../../static/msg-fail.svg';
import config from './config';
import useLoginStatus, { handleLogin } from '../../utils/hooks/useLoginStatus';
import Toast from '../../components/Toast/Toast';
const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);

const selectUserInfo = createSelector(
  state => state.user,
  user => user.userInfo,
);
const selectInstalledSoft = createSelector(
  state => state.native,
  native => native.installedSoft,
);
// const selectDetailGift = createSelector(
//   state => state.adetail,
//   adetail => adetail.detailGift,
// );
// const selectReceiveGift = createSelector(
//   state => state.adetail,
//   adetail => adetail.receiveGift,
// );

export default memo(({ appDetailsData, props }) => {
  const { match } = props;
  const dispatch = useDispatch();
  const userInfo = useSelector(selectUserInfo); // 用户信息
  const logInfoData = useSelector(selectLogInfo);
  // const detailGift = useSelector(selectDetailGift); // 只为拿取礼包数
  const [detailGift, setDetailGift] = useState(null);
  // const receiveGift = useSelector(selectReceiveGift);
  const [receiveGift, setReceiveGift] = useState(null);
  const installedSofts = useSelector(selectInstalledSoft); // 已经安装

  const [isClickBtn, setIsClickBtn] = useState(false); // 温馨提示
  const [isCopy, setIsCopy] = useState(false); // 温馨提示
  const [isSubmitLogin, setIsSubmitLogin] = useState(false); // 领取的时候未登录
  const loginStatus = useLoginStatus();
  const loadingRef = useRef(false);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(async () => {
    try {
      const data = await config.getAAppGift({
        androidType: '1',
        softInfo: match.params.pn || '',
        bizInfo: match.params.bizInfo || {},
        st: userInfo.st || '',
      });
      setDetailGift(data);
    } catch (err) {
      //
    }
  }, [match, userInfo, installedSofts]);

  /**
   * 礼包领取结果
   */
  useEffect(async () => {
    if (receiveGift && receiveGift.data && isClickBtn) {
      if (receiveGift.data.status === 0) {
        try {
          const data = await config.getAAppGift({
            androidType: '1',
            softInfo: match.params.pn || '',
            bizInfo: match.params.bizInfo || {},
          });
          setDetailGift(data);
        } catch (err) {
          //
        }
      }

      dispatch(
        logging({
          category: 'R',
          action: 'AppDetail_Gift_Result',
          label: '',
          param2: {
            source: 'AppDetail',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            softid: appDetailsData.packageName,
            packageName: appDetailsData.packageName,
            versionCode: appDetailsData.versionCode,
            softType: '1',
            status: receiveGift.data.status,
            message: receiveGift.data.message,
            giftid: receiveGift.giftid,
          },
          param3: appDetailsData.bizInfo,
        }),
      );
    }
  }, [dispatch, receiveGift, isClickBtn]);

  /**
   * 登录成功后继续提交信息
   */
  useEffect(() => {
    if (isSubmitLogin === true) {
      if (loginStatus) {
        onClickBtn();
        setIsSubmitLogin(false);
      }
    }
  }, [loginStatus, isSubmitLogin]);

  /**
   * 点击领取礼包
   */
  const onClickBtn = useCallback(
    async giftid => {
      if (installedSofts) {
        const fond = installedSofts.find(
          soft_ =>
            (soft_.androidType !== '1' &&
              (soft_.softID === appDetailsData.softID || soft_.SoftID === appDetailsData.softID)) ||
            (soft_.androidType === '1' && soft_.packageName === appDetailsData.packageName),
        );
        let downloadAppStr = sessionStorage.getItem(todayDownloadApp) || '';
        if (!fond && downloadAppStr.indexOf(appDetailsData.softID) === -1) {
          Toast.error({
            content: '请先安装此应用',
          });
          return;
        }
      }

      if (!loginStatus) {
        handleLogin();
        setIsSubmitLogin(giftid);
      } else {
        if (loadingRef?.current) {
          return;
        }
        loadingRef.current = true;
        setIsClickBtn(true);
        try {
          const data = await config.appAGiftReceive({ androidType: '1', giftid });
          setReceiveGift(data);
          loadingRef.current = false;
          dispatch(
            logging({
              category: 'C',
              action: 'AppDetail_Gift_Receive',
              label: '',
              param2: {
                source: 'AppDetail',
                source_p: logInfoData.source_p,
                source_pp: logInfoData.source_pp,
                softid: appDetailsData.packageName,
                packageName: appDetailsData.packageName,
                versionCode: appDetailsData.versionCode,
                softType: '1',
                giftid,
              },
              param3: appDetailsData.bizInfo,
            }),
          );
        } catch (err) {
          //
        }
      }
    },
    [dispatch, appDetailsData, userInfo, installedSofts],
  );

  const onCopyClick = useCallback(
    value => {
      copy(value);
      setIsCopy(value);
      setTimeout(() => {
        setIsCopy('');
      }, 3000);

      dispatch(
        logging({
          category: 'C',
          action: 'AppDetail_Gift_Copy',
          label: '',
          param2: {
            source: 'AppDetail',
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            softid: appDetailsData.packageName,
            packageName: appDetailsData.packageName,
            versionCode: appDetailsData.versionCode,
            softType: '1',
            value,
          },
          param3: appDetailsData.bizInfo,
        }),
      );
    },
    [appDetailsData],
  );

  return (
    <div className={styles.detail_gift}>
      {detailGift &&
        detailGift.dataList &&
        detailGift.dataList.length > 0 &&
        detailGift.dataList.map((item, i) => (
          <div className="gift_item" key={i}>
            <div className="gift_logo" />
            <div className="gift_info">
              <div className="gift_line">
                <div className="gift_name">{item.name}</div>
                <div className="gift_num">剩余{item.remainder}个</div>
                {item.require && <div className="gift_require">{item.require}</div>}
              </div>
              <div
                className="gift_desc"
                dangerouslySetInnerHTML={{
                  __html: item.description.split('\n').join('<br/>'),
                }}
              />
              <div className="gift_time">有效时间：{item.tendDate}</div>
              {item.code && (
                <div className="gift_code">
                  <div className="gift_code_value">礼包码：{item.code}</div>
                  <div
                    className="gift_code_btn"
                    onClick={() => {
                      onCopyClick(item.code);
                    }}
                  >
                    复制
                  </div>
                  {isCopy === item.code && <div className="gift_code_info">复制成功</div>}
                </div>
              )}
            </div>
            <div className="gift_opt">
              {item.status === '0' && (
                <div
                  className="btn"
                  onClick={() => {
                    onClickBtn(item.id);
                  }}
                >
                  {item.text}
                </div>
              )}
              {item.status === '1' && <div className="btn_disable">{item.text}</div>}
              {(item.status === '2' || item.status === '3') && (
                <div className="btn_grey">{item.text}</div>
              )}
            </div>
          </div>
        ))}
    </div>
  );
});
